import {Field, Form, Formik} from 'formik'
import {sha256} from 'js-sha256'
import * as Yup from 'yup'

import {toast} from 'react-toastify'

import {useIntl} from 'react-intl'
import Logo from '../../../_metronic/assets/logo-white.png'
import BG from '../asset/bg.png'
import {LanguageList} from '../helper/languageList'
import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import PasswordChecklist from 'react-password-checklist'
import {API} from 'src/feature/bite/domain'
import useRequestParams from 'src/feature/bite/hook/request'
import {getTimeZone} from 'src/feature/bite/helpers/date'

export default function NewPassword() {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const {headers} = useRequestParams()

  const [passwordShown, setPasswordShown] = useState(false)
  const [passwordConfirmShown, setPasswordConfirmShown] = useState(false)
  const [passwordValid, setPasswordValid] = useState(false)

  const validationSchema = Yup.object({
    oldPassword: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    password: Yup.string().required(' ').min(6, ' ').max(50, ' '),
    confirmPassword: Yup.string()
      .required(' ')
      .oneOf([Yup.ref('password'), ''], ' '),
    email: Yup.string().email(' ').required(' '),
  })

  useEffect(() => {
    if (!(location as any).state?.email) {
      navigate('/')
    }
  }, [location, navigate])

  const handleSubmit = async (values: any) => {
    if (!passwordValid) {
      return
    }

    //`${API}/Auth/ChangePassword`
    const timeZoneOffset = getTimeZone()

    const Response = await fetch(`${API}/Auth/OutChangePassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      body: JSON.stringify({
        email: values.email,
        oldPassword: sha256(values.oldPassword),
        newPassword: sha256(values.password),
        language: headers.Language,
        timeZoneOffSet: timeZoneOffset,
      }),
    })

    const data = await Response?.json()
    if (!data.responseResult.result) {
      toast.error(intl.formatMessage({id: 'CREATE_PASSWORD.ERROR'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
    } else {
      toast.success(intl.formatMessage({id: 'PASSWORD_CHANGED'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
      window.location.href = '/sign-in'
    }
  }

  return (
    <>
      <div
        className='d-flex flex-column flex-root w-100 justify-content-center align-items-center'
        id='kt_app_root'
      >
        <div
          className='d-flex flex-column flex-lg-row justify-content-between h-100 w-100 position-relative'
          id='loginBg'
        >
          <div
            className='d-flex flex-column w-100 h-100 p-20 justify-content-center align-items-center'
            id='login-right'
          >
            <div
              className='d-flex align-items-center justify-content-center flex-column gap-20'
              style={{
                width: '80%',
              }}
            >
              <div className='w-100 d-flex justify-content-between align-items-center'>
                <div className=''>
                  <a
                    href={process.env.REACT_APP_DEJAVOOEXTRA}
                    className='d-block d-lg-none mx-auto pt-10'
                  >
                    <img alt='Logo' src={Logo} className='h-25px' />
                  </a>

                  <div className='d-flex flex-column gap-4'>
                    <div className='d-none d-md-block'>
                      <a href={process.env.REACT_APP_DEJAVOOEXTRA}>
                        <img alt='Extra360 - Partner Portal' className='h-50px' src={Logo} />
                      </a>
                    </div>
                    <h1 className='fs-1 fw-normal text-white' data-kt-translate='sign-in-title'>
                      {intl.formatMessage({id: 'APP_NAME'})}
                    </h1>
                  </div>

                  <div className='mt-10 w-75'>
                    <h1 className='text-white fs-3x fw-normal'>
                      Unlock New Growth and Elevate Your Business Success with Vasco
                    </h1>
                  </div>

                  <div
                    className='d-flex'
                    style={{
                      marginTop: '5rem',
                    }}
                  >
                    <a
                      className='d-flex align-items-center justify-content-between text-white'
                      href='/become-a-merchant/merchant-form'
                    >
                      <span className='fs-4 fw-bold'>
                        {intl.formatMessage({id: 'AUTH.LOGIN.BECOME_MERCHANT'})}
                      </span>

                      <i className='bi bi-arrow-right fs-2 text-white ms-3'></i>
                    </a>
                  </div>
                </div>

                <div
                  className='card ps-5 d-flex flex-column justify-content-center'
                  style={{
                    minHeight: '600px',
                    width: '50%',
                  }}
                >
                  <Formik
                    className='form w-100'
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    initialValues={{
                      oldPassword: '',
                      password: '',
                      confirmPassword: '',
                      email: (location as any).state?.email,
                    }}
                  >
                    {({errors, values, touched}) => (
                      <Form className='py-10 px-5'>
                        <div className='text-start mb-7'>
                          <h1 className='text-primary mb-3 fs-3x' data-kt-translate='sign-in-title'>
                            {intl.formatMessage({id: 'AUTH.LOGIN.CREATE_PW'})}
                          </h1>

                          <div
                            className='text-gray-400 fw-semibold fs-6'
                            data-kt-translate='password-reset-desc'
                          >
                            {intl.formatMessage({id: 'AUTH.LOGIN.CREATE_PW_DESC'})}
                          </div>
                        </div>
                        <div className='fv-row mb-7 form-floating w-75'>
                          <Field
                            type='password'
                            id='oldPassword'
                            name='oldPassword'
                            className='form-control mb-2'
                            placeholder='Old Password'
                          />
                          <label>{intl.formatMessage({id: 'AUTH.INPUT.OLD_PASSWORD'})}</label>
                          {errors.oldPassword && touched.oldPassword && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{errors.oldPassword}</div>
                            </div>
                          )}
                        </div>
                        <div className='fv-row mb-7 form-floating w-75'>
                          {/* eye icon */}
                          <div
                            className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                            style={{cursor: 'pointer'}}
                            onClick={() => setPasswordShown(!passwordShown)}
                          >
                            <i
                              className={`bi ${passwordShown ? 'bi-eye-slash' : 'bi-eye'}`}
                              style={{fontSize: '1.4rem'}}
                            ></i>
                          </div>
                          <Field
                            type={passwordShown ? 'text' : 'password'}
                            name='password'
                            className='form-control mb-2'
                            placeholder='Password'
                          />
                          <label>{intl.formatMessage({id: 'AUTH.INPUT.NEW_PASSWORD'})}</label>
                          {/* {errors.password && touched.password && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.password}</div>
                        </div>
                      )} */}
                        </div>

                        <div className='fv-row mb-7 form-floating w-75'>
                          <div
                            className='position-absolute top-50 end-0 translate-middle-y fs-10 pe-6'
                            style={{cursor: 'pointer'}}
                            onClick={() => setPasswordConfirmShown(!passwordConfirmShown)}
                          >
                            <i
                              className={`bi ${passwordConfirmShown ? 'bi-eye-slash' : 'bi-eye'}`}
                              style={{fontSize: '1.4rem'}}
                            ></i>
                          </div>
                          <Field
                            type={passwordConfirmShown ? 'text' : 'password'}
                            name='confirmPassword'
                            className='form-control mb-2'
                            placeholder='Confirm Password'
                          />
                          <label>
                            {intl.formatMessage({id: 'AUTH.INPUT.NEW_CONFIRM_PASSWORD'})}
                          </label>
                          {/*  {errors.confirmPassword && touched.confirmPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{errors.confirmPassword}</div>
                        </div>
                      )} */}
                        </div>

                        <div>
                          <PasswordChecklist
                            className='mb-7'
                            rules={[
                              'minLength',
                              'specialChar',
                              'number',
                              'capital',
                              'lowercase',
                              'match',
                            ]}
                            minLength={6}
                            value={values.password}
                            valueAgain={values.confirmPassword}
                            onChange={(isValid) => {
                              setPasswordValid(isValid)
                            }}
                            messages={{
                              minLength: intl.formatMessage({
                                id: 'FORGOT.PASSWORD.RULES.MIN_LENGTH',
                              }),
                              specialChar: 'At least one special character (e.g. !@#$%^&*)',
                              number: 'At least one number (e.g. 0-9)',
                              capital: 'At least one capital letter (e.g. A-Z)',
                              lowercase: 'At least one lowercase letter (e.g. a-z)',
                              match: 'Passwords must match',
                            }}
                          />
                        </div>
                        <div className='d-flex flex-stack'>
                          <div className='m-0'>
                            <button
                              // id='kt_password_reset_submit'
                              type='submit'
                              className='btn btn-primary me-2'
                              // data-kt-translate='password-reset-submit'
                            >
                              <i className='bi bi-arrow-right me-3 fs-3'></i>
                              <span className='indicator-label'>
                                {intl.formatMessage({id: 'AUTH.GENERAL.SUBMIT_BUTTON'})}
                              </span>

                              <span className='indicator-progress'>
                                {intl.formatMessage({id: 'PLEASE_WAIT'})}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                              </span>
                            </button>
                            <a
                              href='sign-in'
                              className='btn fw-bold'
                              data-kt-translate='password-reset-cancel'
                            >
                              {intl.formatMessage({id: 'AUTH.GENERAL.BACK_BUTTON'})}
                            </a>
                          </div>
                        </div>
                        {/* <div className='mt-10'>
                          <LanguageList />
                        </div> */}
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
